// SimpleLayout.js
import React, { Suspense } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import  AppHeader from '../../components/header/Header';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';

const { Header, Content } = Layout;

const LoginLayout=() =>{
  const { isLoading } = useSelector((state: RootState) => state.loading);

  return (
    <Suspense fallback={isLoading}> <Layout style={{ minHeight: '100vh' }}>
      <Header className="site-layout-background">
      <AppHeader/>
      </Header>
      <Content style={{ padding: '0 0', minHeight: 280 }}>
        <Outlet />
      </Content>
    </Layout>
    </Suspense>
  );
}

export default LoginLayout;
